import React from 'react';
import Spinner from 'react-spinkit';
import styled from 'styled-components';

import { Colors } from '../theme';

const Container = styled.div`
  display: inline-block;
  margin-right: .5em;
  transform: translateY(-.1em);
  vertical-align: middle;

  ${props => {
    if (props.$fullscreen) {
      return `
        display: block;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      `;
    }
  }}

  .ball-scale-ripple > div {
    height: ${props => props.size === 'small' ? 16 : props.size === 'xsmall' ? 8 : 50}px;
    width: ${props => props.size === 'small' ? 16 : props.size === 'xsmall' ? 8 : 50}px;
  }
`;

const FullScreenSpinner = styled(Spinner)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div`
  color: ${Colors.brand.lightGrey};
  font-size: 1.125em;
  font-weight: 300;
  margin-top: .75em;
  text-align: center;
`;

const Loader = ({ message, fullscreen = true, size }) => {
  const spinnerProps = {
    name: 'ball-scale-ripple',
    color: Colors.brand.primary,
    fadeIn: 'quarter'
  };

  return (
    <Container size={size} $fullscreen={fullscreen}>
      {fullscreen && <FullScreenSpinner {...spinnerProps} />}
      {!fullscreen && <Spinner {...spinnerProps} />}
      {message && <Message>{message}</Message>}
    </Container>
  );
};

export default Loader;
